export default __webpack_public_path__ + "static/media/logo-mishras.811e08ae.jpg";